<template>
  <div>
    <Authenticate/>
    <v-container>
      <v-data-table
          :headers="headers"
          :items="clients"
          :items-per-page="15"
          class="elevation-1">
      <!-- Top slot for toolbar and other elements -->
        <template v-slot:top>
          <v-toolbar color="white" flat>
            <v-toolbar-title>Dashboard Database</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <alert :message="message" :variant="variant" v-if="showMessage"></alert>
            <v-alert :value="showError" type="error" dismissible>{{ error }}</v-alert>
            <v-spacer></v-spacer>
            <v-dialog max-width="500px" v-model="dialog">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2" color="primary" dark v-on="on">Add Member</v-btn>
              </template>
              <!-- Card for adding/editing a member -->
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row align="start" justify="start">
                      <v-col cols="12" md="6" sm="8">
                        <v-text-field label="First Name"
                                      placeholder="John"
                                      required
                                      v-model="editedItem.first_name">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="8">
                        <v-text-field label="Last Name"
                                      placeholder="DOE"
                                      required
                                      v-model="editedItem.last_name">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="8">
                        <v-text-field label="Email"
                                      placeholder="john.doe@renault.com"
                                      required
                                      v-model="editedItem.email">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="8">
                        <v-text-field label="Company"
                                      placeholder="Renault"
                                      required
                                      v-model="editedItem.company">
                        </v-text-field>
                      </v-col>

                      <v-col
                        class="d-flex"
                        cols="12"
                        md="6"
                        sm="8">
                        <v-select
                          :items="dashboard_types"
                          label="Dashboard type"
                          v-model="editedItem.dashboard"
                        ></v-select>
                      </v-col>

                      <v-col
                        class="d-flex"
                        cols="12"
                        md="6"
                        sm="8"
                      >
                        <v-select
                          :items="countries"
                          item-text="label"
                          item-value="code"
                          label="Country"
                          v-bind:disabled="editedItem.organisation !== 'COUNTRY'"
                          v-model="editedItem.country"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="6" sm="8">
                        <p>Organisation</p>
                        <input id="corporate" type="radio" v-model="editedItem.organisation"
                              value="CORPORATE">
                          <label for="corporate"> CORPORATE</label>
                        <br>
                        <input id="europe" type="radio" v-model="editedItem.organisation"
                              value="EUROPE">
                          <label for="europe"> EUROPE</label>
                        <br>
                        <input id="eurasie" type="radio" v-model="editedItem.organisation"
                              value="EURASIE">
                          <label for="eurasie"> EURASIE</label>
                        <br>
                        <input id="latam" type="radio" v-model="editedItem.organisation"
                              value="LATAM">
                          <label for="latam"> LATAM</label>
                        <br>
                        <input id="amip" type="radio" v-model="editedItem.organisation"
                              value="AMIP">
                          <label for="amip"> AMIP</label>
                        <br>
                        <input id="france" type="radio" v-model="editedItem.organisation"
                              value="FRANCE">
                          <label for="france"> FRANCE</label>
                        <br>
                        <input id="country" type="radio" v-model="editedItem.organisation"
                              value="COUNTRY">
                          <label for="country"> COUNTRY</label>
                        <br>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close" color="blue darken-1" text>Cancel</v-btn>
                  <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
                </v-card-actions>

              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-text-field @input="search" color="success" placeholder="Search"></v-text-field>
        </template>
        <!-- Template for actions slot -->
        <template v-slot:item.actions="{ item }">
          <v-icon @click="editItem(item)" class="mr-2" small>mdi-pencil</v-icon>
          <v-icon @click="deleteItem(item)" class="mr-2" small>mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Alert from './Alert.vue';
import Authenticate from './Authenticate.vue';

export default {
  components: {
    Authenticate,
    Alert,
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    formTitle() {
      return this.editedIndex === -1 ? 'Add Client' : 'Edit Client';
    },
  },
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      headers: [
        {
          text: 'Member ID',
          align: 'start',
          sortable: false,
          value: 'key',
        },
        { text: 'First name', value: 'first_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Company', value: 'company' },
        { text: 'Organisation', value: 'organisation' },
        { text: 'Dashboard', value: 'dashboard' },
        { text: 'Country', value: 'country' },
        { text: 'Creation date', value: 'current_date' },
        { text: 'Author', value: 'author' },
        { text: 'Actions', value: 'actions' },
      ],
      clients: [],
      editedItem: {
        key: '',
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        organisation: '',
        dashboard: '',
        country: '',
        author: this.$store.getters.userMail,
      },
      defaultItem: {
        key: '',
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        organisation: '',
        dashboard: '',
        country: 'XXX',
        author: this.$store.getters.userMail,
      },
      message: '',
      variant: 'success',
      showMessage: false,
      error: '',
      showError: false,
      dashboard_types: ['RSI', 'Profiling'],
      countries: [
        { code: 'XXX', label: 'If no Country' },
        { code: 'DZA', label: 'Algeria' },
        { code: 'ARG', label: 'Argentina' },
        { code: 'AUT', label: 'Austria' },
        { code: 'BEL', label: 'Belgium' },
        { code: 'BRA', label: 'Brazil' },
        { code: 'COL', label: 'Colombia' },
        { code: 'HRV', label: 'Croatia' },
        { code: 'CZE', label: 'Czech Republic' },
        { code: 'DNK', label: 'Denmark' },
        { code: 'FRA', label: 'France' },
        { code: 'DEU', label: 'Germany' },
        { code: 'HUN', label: 'Hungary' },
        { code: 'IRL', label: 'Ireland' },
        { code: 'ITA', label: 'Italy' },
        { code: 'LUX', label: 'Luxembourg' },
        { code: 'MAR', label: 'Maroc' },
        { code: 'MEX', label: 'Mexico' },
        { code: 'NLD', label: 'Netherlands' },
        { code: 'NOR', label: 'Norway' },
        { code: 'POL', label: 'Poland' },
        { code: 'PRT', label: 'Portugal' },
        { code: 'ROU', label: 'Romania' },
        { code: 'RUS', label: 'Russia' },
        { code: 'SVK', label: 'Slovakia' },
        { code: 'SVN', label: 'Slovenia' },
        { code: 'ESP', label: 'Spain' },
        { code: 'SWE', label: 'Sweden' },
        { code: 'CHE', label: 'Switzerland' },
        { code: 'TUR', label: 'Turkey' },
        { code: 'GBR', label: 'UK' },
      ],
    };
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line
      val || this.close();
    },
  },
  methods: {
    getDashboard(path = '/api/dashboard') {
      if (!this.$store.getters.isAuthenticated) {
        // this.error = 'You must be logged in to view this data.';
        // this.showError = true;
        return;
      }
      axios.get(path)
        .then((res) => {
          this.clients = res.data.clients;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          if (error.response && error.response.status === 403) {
            this.error = 'Access Denied. You do not have permission to view this data';
            this.showError = true;
          }
        });
    },

    search(val) {
      console.log(val);
      const path = `/api/dashboard?q=${val}`;
      this.getDashboard(path);
    },

    deleteItem(item) {
      // eslint-disable-next-line
      confirm('Are you sure you want to delete this item?') && this.removeMember(item.key);
    },
    editItem(item) {
      this.editedIndex = this.clients.indexOf(item);
      // eslint-disable-next-line
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        // eslint-disable-next-line
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        this.editMember(this.editedItem);
      } else {
        this.addMember(this.editedItem);
      }
      this.close();
    },
    addMember(payload) {
      const path = '/api/dashboard';
      axios.post(path, payload)
        .then((res) => {
          this.getDashboard();
          this.message = res.data.message;
          if (this.message !== 'Member added!') {
            this.variant = 'danger';
          } else {
            this.variant = 'success';
          }
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.error = error.response.data.error;
          this.showError = true;
          this.getDashboard();
        });
    },
    removeMember(MemberId) {
      const path = `/api/dashboard/${MemberId}`;
      axios.delete(path)
        .then(() => {
          this.getDashboard();
          this.message = 'Member removed!';
          this.variant = 'success';
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
      console.error(error);
          this.getDashboard();
        });
    },
    editMember(payload) {
      const memberId = payload.key;
      const path = `/api/dashboard/${memberId}`;
      axios.post(path, payload)
        .then((res) => {
          this.getDashboard();
          this.message = res.data.message;
          if (this.message !== 'Member modified!') {
            this.variant = 'danger';
          } else {
            this.variant = 'success';
          }
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          this.error = error.response.data.error;
          this.showError = true;
          this.getDashboard();
        });
    },
  },
  created() {
    if (this.$store.getters.isAuthenticated) {
      this.getDashboard();
    } else {
      this.error = 'Please sign in to access the dashboard.';
      this.showError = true;
    }
  },
};
</script>
